<template>
  <form @submit.prevent="$emit('submit', userToSubmit)">
    <v-select
      v-if="!self && usertypes.length"
      :items="usertypes"
      filled
      label="Тип пользователя"
      item-text="description"
      item-value="name"
      v-model="type"
    ></v-select>
    <v-progress-circular
      v-else-if="!self && !usertypes.length"
      class="ml-1 mb-5"
      indeterminate
      size="32"
    ></v-progress-circular>

    <v-text-field
      label="Почта"
      placeholder=""
      filled
      v-model="email"
      :disabled="self"
    ></v-text-field>

    <v-text-field
      label="ФИО"
      placeholder=""
      filled
      v-model="name"
    ></v-text-field>

    <v-text-field
      label="Пароль"
      placeholder=""
      filled
      v-model="password"
      type="password"
    ></v-text-field>

    <v-text-field
      label="Пароль ещё раз"
      placeholder=""
      filled
      v-model="passwordAgain"
      type="password"
    ></v-text-field>
    <ul style="color:red">
      <li v-if="password.length > 0 && password.length < 6">
        Минимальная длина пароля 6 символов
      </li>
      <li v-if="password !== passwordAgain">Пароли не совпадают</li>
    </ul>
    <v-row v-if="codeNeeded">
      <v-col>
        <v-text-field
          label="Код"
          placeholder=""
          filled
          v-model="code"
        ></v-text-field>
      </v-col>
      <v-col>
        <get-code :email="email" />
      </v-col>
    </v-row>

    <v-checkbox label="Активен" v-model="active" v-if="!self" />

    <v-checkbox
      label="Индивидуальный интервал смены паролей"
      v-model="individualPasswordDrop"
      v-if="!self"
    />
    <div v-if="individualPasswordDrop">
      <v-text-field
        label="Интевал, дней"
        placeholder="90"
        filled
        v-model="passwordDropInterval"
      ></v-text-field>
    </div>

    <v-btn
      v-if="password.length === 0 || passwordsMatch"
      color="primary"
      type="submit"
      >Сохранить</v-btn
    >
  </form>
</template>

<script>
import GetCode from "./GetCode";
import api from "../api";
import axios from "axios";

export default {
  name: "user-form",
  props: ["user", "self"],
  components: {
    GetCode
  },
  data() {
    return this.user.id !== undefined
      ? {
          name: this.user.name,
          active: this.user.active,
          email: this.user.email,
          password: "",
          passwordAgain: "",
          code: "",
          individualPasswordDrop: this.user.individualPasswordDrop,
          passwordDropInterval: this.user.passwordDropInterval,
          loading: false,
          usertypes: [],
          type: this.user.type
        }
      : {
          name: "",
          active: true,
          email: "",
          password: "",
          passwordAgain: "",
          code: "",
          individualPasswordDrop: false,
          passwordDropInterval: 0,
          loading: false,
          usertypes: [],
          type: ""
        };
  },
  computed: {
    userToSubmit() {
      let user = {
        active: this.active,
        name: this.name,
        email: this.email,
        password: this.password,
        individualPasswordDrop: this.individualPasswordDrop,
        passwordDropInterval: this.passwordDropInterval,
        type: this.type //для теста
      };

      let code = { code: this.code };

      // если нужено отправлять код, то возвращаем объект с кодом, если нет - без кода
      return this.codeNeeded ? { ...user, ...code } : user;
    },
    passwordsMatch() {
      return this.password.length > 5 && this.password === this.passwordAgain;
    },
    codeNeeded() {
      return this.self && this.passwordsMatch;
    }
  },
  methods: {
    getUserTypes() {
      axios.get(api.usertypes).then(resp => {
        this.usertypes = resp.data;
      });
    }
  },
  mounted() {
    this.getUserTypes();
  }
};
</script>

<style></style>
